export const isZigzinShop = (shopId: string) => {
  return shopId === '20017' || shopId === '9038';
};

export const getZigzinShopId = () => {
  const is_prod = ['store.zigzag.kr', 'store.beta.zigzag.kr', 'zigzag.kr', 'beta.zigzag.kr'].includes(
    window.location.hostname,
  );

  if (is_prod) {
    return '9038';
  }
  return '20017';
};
